import { configureStore } from '@reduxjs/toolkit'
import addedJobSlice from './slicers/addedJobSlicer'
import selectedStep from './slicers/selectedStepSlicer'
import employeeSlicer from'./slicers/employeeSlicer'
import keySlicer from './slicers/keySlicer'
import stepOneSlicer from './slicers/stepOneSlicer'
import stepTwoSlicer from './slicers/stepTwoSlicer'
export default configureStore({
  reducer: {
    addedJob: addedJobSlice,
    selectedStep: selectedStep,
    employeeSlicer: employeeSlicer,
    keySlicer: keySlicer,
    stepOne:stepOneSlicer,
    stepTwo: stepTwoSlicer
  },
})